import { Outlet } from 'react-router-dom';
import '../widget-components.css';

/**
 * Layout for the embeddable chat widget (iframe mode).
 * Intentionally minimal — no sidebar, no admin chrome.
 * Designed to fill the full iframe viewport.
 */
export default function WidgetLayout() {
  return (
    <div
      className="flex h-screen w-full flex-col overflow-hidden"
      style={{ background: 'oklch(0.23 0.02 237)' }}
    >
      <Outlet />
    </div>
  );
}
